import Data from "source/app/services/Data";
import { HandlePostingDailyGoalAsync } from "source/app/presentation/MainPanel/Goals/DailyGoals/DailyGoal/HandlePostingDailyGoalAsync";
import { DailyGoals } from "./DailyGoals";
import { GetActiveDailyGoals } from "./GetActiveDailyGoals";

export async function PostDailyGoalsToLogAsync(DailyGoals: DailyGoals) {
    try {
        const activeDailyGoals = GetActiveDailyGoals(
            DailyGoals.props.GoalsContainer
        );

        DailyGoals.setState({ isPosting: true });

        for (const checkedGoalName of DailyGoals.state.checkedGoals) {
            const dailyGoal = activeDailyGoals.find(
                (goal) => goal.name === checkedGoalName
            )!;

            await HandlePostingDailyGoalAsync(dailyGoal);
        }
    } finally {
        DailyGoals.setState({ isPosting: false, checkedGoals: [] }, () =>
            Data.Load.AllAsync()
        );
    }
}
